// Lightweight inline icons for the nav rail. Stroke-based, 24x24 viewBox.

/**
 * Brand mark used in the nav rail. 62×62 viewBox so the original stroke
 * weights and gradient stops keep their proportions when scaled down to
 * the 44×44 nav-logo slot.
 */
export function LogoMark() {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 62 62'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5892 35.881L14.2598 40.1219C13.6437 40.4783 12.8844 39.9809 12.9653 39.2737L12.7772 23.6544C12.7726 23.2752 12.9731 22.9231 13.3015 22.7335C13.6363 22.5402 14.0502 22.5468 14.3787 22.7505L21.7205 27.3042C24.9303 29.295 24.8585 33.9894 21.5892 35.881Z'
        fill='url(#logo_paint0)'
      />
      <path
        d='M42.593 44.8556L35.1965 49.5559C34.6939 49.8753 34.0264 49.7116 33.7286 49.1958C33.6389 49.0404 33.5906 48.8645 33.5884 48.6851L33.4039 33.3642C33.3992 32.9698 33.6077 32.6035 33.9494 32.4062C34.2744 32.2186 34.673 32.2111 35.0048 32.3865L42.2479 36.2151C45.6406 38.0085 45.8319 42.7973 42.593 44.8556Z'
        fill='url(#logo_paint1)'
      />
      <path
        d='M31.0365 18.9074L31.093 11.3359C31.0973 10.7678 30.5401 10.3651 30.002 10.5473L14.8371 17.417C14.5251 17.5584 14.3247 17.8692 14.3247 18.2117C14.3247 18.5463 14.516 18.8514 14.8172 18.9971L23.8594 23.3711C27.165 24.9702 31.0091 22.5794 31.0365 18.9074Z'
        fill='url(#logo_paint2)'
      />
      <path
        d='M44.9207 17.0283C46.388 17.7018 46.4723 18.9718 45.0983 19.708L33.1304 26.1206C31.9558 26.75 30.1389 26.75 28.9643 26.1206L16.9964 19.708C15.6224 18.9718 15.7067 17.7018 17.174 17.0283L29.1428 11.5352C30.2581 11.0235 31.8366 11.0235 32.9519 11.5352L44.9207 17.0283Z'
        stroke='black'
        strokeWidth='3'
      />
      <rect
        x='1.29904'
        y='2.25'
        width='16.8682'
        height='16.8682'
        rx='2.5'
        transform='matrix(0.866025 0.5 0 1 12.5183 20.5897)'
        stroke='black'
        strokeWidth='3'
      />
      <rect
        x='1.29904'
        y='0.75'
        width='16.8682'
        height='16.8682'
        rx='2.5'
        transform='matrix(0.866025 -0.5 0 1 33.1447 31.8233)'
        stroke='black'
        strokeWidth='3'
      />
      <defs>
        <linearGradient
          id='logo_paint0'
          x1='7.54459'
          y1='29.8847'
          x2='27.0509'
          y2='30.8712'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3311' />
          <stop offset='1' stopColor='#FFAABB' />
        </linearGradient>
        <linearGradient
          id='logo_paint1'
          x1='28.171'
          y1='39.5698'
          x2='47.6774'
          y2='40.5563'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#66FF11' />
          <stop offset='1' stopColor='#66CC33' />
        </linearGradient>
        <linearGradient
          id='logo_paint2'
          x1='24.272'
          y1='10.5473'
          x2='24.272'
          y2='26.1936'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#977EB5' />
          <stop offset='1' stopColor='#7F14FF' />
        </linearGradient>
      </defs>
    </svg>
  );
}

// Icon glyphs below are Lucide (https://lucide.dev, ISC license) paths
// inlined to avoid the runtime dep. Stroke width kept at 1.5 to match
// the existing nav-rail visual weight.

export function ResilienceIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5' />
      <path d='M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27' />
    </svg>
  );
}

export function TalentIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z' />
    </svg>
  );
}

export function TimelineIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
      <path d='M3 3v5h5' />
      <path d='M12 7v5l4 2' />
    </svg>
  );
}

export function RoadmapIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m12.99 6.74 1.93 3.44' />
      <path d='M19.136 12a10 10 0 0 1-14.271 0' />
      <path d='m21 21-2.16-3.84' />
      <path d='m3 21 8.02-14.26' />
      <circle cx='12' cy='5' r='2' />
    </svg>
  );
}

export function ActivityIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2' />
    </svg>
  );
}

export function AccountingIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z' />
      <path d='M14 8H8' />
      <path d='M16 12H8' />
      <path d='M13 16H8' />
    </svg>
  );
}

// Sub-nav icons for the Accounting feature. Sized to render inline
// with tab labels — the component itself stays 24x24 so callers can
// scale via CSS width/height (currentColor stroke matches text).

export function PieChartIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21.21 15.89A10 10 0 1 1 8 2.83' />
      <path d='M22 12A10 10 0 0 0 12 2v10z' />
    </svg>
  );
}

export function ScaleIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z' />
      <path d='m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z' />
      <path d='M7 21h10' />
      <path d='M12 3v18' />
      <path d='M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2' />
    </svg>
  );
}

export function UsersIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
      <circle cx='9' cy='7' r='4' />
      <path d='M22 21v-2a4 4 0 0 0-3-3.87' />
      <path d='M16 3.13a4 4 0 0 1 0 7.75' />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2' />
      <circle cx='12' cy='7' r='4' />
    </svg>
  );
}

export function FlagIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' />
      <line x1='4' x2='4' y1='22' y2='15' />
    </svg>
  );
}

/** Chevron pointing left — used by the "Back" secondary-function button. */
export function ChevronLeftIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='m15 18-6-6 6-6' />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    >
      <circle cx='12' cy='12' r='3' />
      <path
        d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
